import axios from 'axios';
import { CLOUD_SERVICE_BASE_URL } from '@/utils/const';
import store from '@/store';
import { attachTokenRefresh } from '@/utils/authInterceptors';

// Create fedexPickupRequest service similar to va-portal
const fedexPickupRequest = axios.create({
  baseURL: process.env.VUE_APP_ENV === "production"
    ? `${CLOUD_SERVICE_BASE_URL}/lis/shipping`
    : `${CLOUD_SERVICE_BASE_URL}/lis/shipping/staging`
});

fedexPickupRequest.interceptors.request.use(
  function(config) {
    let token = store?.state?.login?.token || localStorage.getItem("jwtToken") || "";
    config.headers["Authorization"] = token ? `Bearer ${token}` : "";
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

attachTokenRefresh(fedexPickupRequest);

export async function validateAddressWithFedex(streetAddress, city, state, zipcode, country) {
  // streetAddress: a single street line, or an array of lines
  // (e.g. [address_line_1, address_line_2]) sent as separate street_lines.
  const streetLines = (Array.isArray(streetAddress) ? streetAddress : [streetAddress])
    .filter(line => line && String(line).trim());
  // No usable street line: report invalid without calling the API, matching
  // the legacy [""] behavior (FedEx NOTFOUND → invalid) — an empty
  // street_lines array could 400 instead and fail open as "error".
  if (streetLines.length === 0) {
    return {
      status: "invalid",
      resolved: null
    };
  }
  const payload = {
    addresses: [
      {
        street_lines: streetLines,
        city,
        state_or_province_code: state,
        postal_code: zipcode,
        country_code: country,
      }
    ]
  };

  try {
    // Use the correct endpoint like va-portal: /pickups/v2/addresses/validation
    const res = await fedexPickupRequest.post("/pickups/v2/addresses/validation", payload);
    const resolved = res.data.resolved_addresses?.[0];

    if (!resolved || resolved.customer_messages?.some(msg => msg.code === "STANDARDIZED.ADDRESS.NOTFOUND")) {
      console.log("Invalid address.");
      return {
        status: "invalid",
        resolved: null
      };
    }

    const inputStreet = streetLines.join(" ").replace(/\s+/g, " ").trim();
    const inputParts = [inputStreet, city, state, zipcode, country].filter(Boolean);
    const inputStr = inputParts.join(", ").toUpperCase();
    const suggestedStreet = (resolved.street_lines_token || []).join(" ");
    const suggestedParts = [
      suggestedStreet,
      resolved.city,
      resolved.state_or_province_code,
      resolved.postal_code,
      resolved.country_code
    ].filter(Boolean);
    const suggestedStr = suggestedParts.join(", ").toUpperCase().replace(/\s+/g, " ").trim();

    if (inputStr !== suggestedStr) {
      return {
        status: "suggested",
        resolved
      };
    }

    return {
      status: "valid",
      resolved
    };

  } catch (error) {
    return {
      status: "error",
      resolved: null
    };
  }
}
